import { render, staticRenderFns } from "./scc-input-new-validator.vue?vue&type=template&id=b9b3d080&scoped=true&"
import script from "./scc-input-new-validator.vue?vue&type=script&lang=js&"
export * from "./scc-input-new-validator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b3d080",
  null
  
)

export default component.exports